import { get } from "../../utils/objectHelpers";

$ {
    const mainModules = get(input, 'regionsData.MAIN', []);
    const spinnerModule = mainModules.find(m => m.meta && m.meta.name === 'LOADING_SPINNER');
    const modules = get(input, 'regionsData.TAB0', []);
    const gridModule = modules.find(m => m.meta && m.meta.name === 'ITEMS_GRID');
    const sortModule = modules.find(m => m.meta && m.meta.name === 'SORT_ITEMS_SELECTION');
    const container = get(gridModule, "containers.[0]", {});
    const cards = get(container, "cards", []);
    const imageSize = gridModule && gridModule.isSmall ? 170 : 300;
    const title = get(gridModule, "containers.[0].title", null);
    const seeAllTextSpans = get(container, "seeAll.textSpans", []);
    const seeAllAction = get(container, "seeAll.action", {});
}

<section class="str-items-grid app-layout__block--gutters">
    <div class="str-marginals str-marginals__header">
        <str-title ...title />
        <str-sort ...sortModule title=title/> 
    </div>
    <section class="str-items-grid__container">
        <for|card, idx| of=cards>
            <str-item-card key=idx ...card class=card._type imageSize=imageSize isSmall=gridModule.isSmall />
        </for>
    </section>
    <div class="str-marginals str-marginals__footer">
        <ebay-button
            class="str-marginals__footer--button"
            priority="primary"
            size="large"
            href=seeAllAction.URL
            fluid
            >
            <str-textual-display textSpans=seeAllTextSpans />
        </ebay-button>
    </div>
    <str-loading-spinner ...spinnerModule spinnerId="listingsLoadingSpinner"/> 
</section>
